import React from 'react'
import $ from 'jquery'

import './ItemSearch.css'


class ItemSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            choseItem: false,
            searchItems: '',
        }

        this.newSearch = this.newSearch.bind(this);
        this.openSearch = this.openSearch.bind(this);
        this.enterSearch = this.enterSearch.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.choseItem = this.choseItem.bind(this);
    }

    newSearch() {
        if (!this.state.choseItem)
            $('div#itemsearch').css('display', 'none')
        else
            this.setState({ choseItem: false })

        this.props.newSearch(this.state.searchItems)
    }

    openSearch(e) {
        this.setState({ choseItem: false })
        $('div#itemsearch').css('display', 'block')
    }

    enterSearch(e) {
        this.setState({ searchItems: e.target.value })
    }

    selectItem(e) {
        this.setState({ searchItems: e.target.innerText })

        $('input#itemsearch').focus().val(e.target.innerText)
        $('div#itemsearch').css('display', 'none')
    }

    choseItem() {
        this.setState({ choseItem: true })
    }

    render() {
        return (
            <div className="ItemSearch">
                <input
                    id="itemsearch"
                    autocomplete="off"
                    onBlur={this.newSearch}
                    onClick={this.openSearch}
                    onChange={this.enterSearch}
                />
                {
                    this.props.items.length ?
                        <div id="itemsearch" onMouseEnter={this.choseItem} >
                            {
                                this.props.items.filter((item) => {
                                    if (this.state.searchItems == '')
                                        return true
                                    else
                                        return item.toLowerCase().startsWith(this.state.searchItems.toLowerCase())
                                })
                                .map((item, index) => {
                                    if (this.state.searchItems == '')
                                        return <p key={index} item={item} onClick={this.selectItem}>{item}</p>
                                    else 
                                        return <p key={index} item={item} onClick={this.selectItem}><span>{item.substring(0, this.state.searchItems.length)}</span>{item.substring(this.state.searchItems.length)}</p>
                                })
                            }
                        </div>
                    :
                        null
                }
            </div>
        );
    }
}

export default ItemSearch
